export const headerConfig = {
  tabs: [
    'Patients',
    'Connect',
    'Leads',
    'Studies',
    'Account',
    'ancillary_products',
    'Store',
    'Education',
    'SubscriptionProgram',
    'Profile',
    'Support',
    'Practice Marketing Resources',
    'Collaboration',
    'Ideas',
    'TPS',
    'VirtualCare',
    'Analytics',
  ],
  dropDown: [
    'DrProfile',
    'StaffProfile',
    'ClinicalPreference',
    'Practice Development',
    'Invisalign Pro',
    'Promotions',
    'SmileView Setup',
    'Help',
    'logout',
  ],
  currentlyActiveTab: 'Store',
};
